import { Box } from "@chakra-ui/react";
import CreditCards from "./CreditCards";
import ExpenseReports from "./ExpenseReports";

export default function Billing() {
  return (
    <Box>
      <CreditCards />
      <ExpenseReports />
    </Box>
  );
}
